<template>
  <div class="row justify-content-md-center px-4">
    <div class="col-12 form-group p-4">
      <label class="form-control-label text-left justify-content-start">{{ anosafra.descricao }}</label><br>
      <div class="row justify-content-md-start">
        <div class="col-md-12">
          <multiselect
            v-model="selectedChannels"
            :options="channels"
            :multiple="true"
            :close-on-select="false"
            track-by="id"
            label="description"
            placeholder="Selecione um segmento"
            :limit="1"
            :limit-text="limitText"
            @input="onChannelsChange"
            rules="required"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from "vue";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

const props = defineProps({
  value: { type: Array, default: () => [] },
  anosafra: { type: Object, default: () => ({}) },
  channels: { type: Array, default: () => [] }
});

const emit = defineEmits(['input']);

const selectedChannels = ref([...props.value]);

function arraysAreEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;
  return arr1.every((val, index) => val.id === arr2[index].id);
}

watch(() => props.value, (newValue) => {
  if (!arraysAreEqual(selectedChannels.value, newValue)) {
    selectedChannels.value = [...newValue];
  }
});

const limitText = (count) => {
  return `+ ${count}`;
};

const onChannelsChange = (value) => {
  selectedChannels.value = value;

  if (!arraysAreEqual(value, props.value)) {
    emit('input', value);
  }
};
</script>

<style lang="scss" scoped>
.form-group {
  background-color: #e9ecef;
  border-radius: 10px;
}
</style>
